import React, { useState, useEffect } from "react";
import "./Posp.css";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Previousinsurer,
  QuickQuote_Post,
  quick_quoteValues,
  addVahanData,
  quick_quotes_Bike,
  addbikedetails,
  OnSendReq,
} from "../../Redux/actions/NumBikeation";
import axios from "axios";
import { PospNavBar } from "../Navbar/PospNav";
import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Row,
  Col,
  AutoComplete,
  Button,
  DatePicker,
  Radio,
  Select,
  message,
  Upload,
} from "antd/lib";
import moment from "moment";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
function PospMake(props) {
  console.log("propss", props.preinslist);
  const bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const QuoteRequest = useSelector((state) => state?.common?.quoteRequest);
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const vehicleDetails = useSelector(
    (state) => state.vehicledetail.bikeMakeData
  );
  const auth = useSelector((state) => state?.vehicledetail?.bikenum);
  const QuickPost = useSelector((state) => state?.vehicledetail?.quoteInput);
  const PospToken = useSelector((state) => state?.posp?.Posp);
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [bikeNumDetail, setBikeNumdeail] = useState(bikenum);
  const [notExp, setnotExp] = useState(
    QuickPost?.currentPolicyExpired === "NotExpired" ? true : false
  );
  const [bikenumDetails, setbikenumDetails] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [NotSecure, setNotSecure] = useState(
    QuickPost?.previous_policy_type === "Not-Secure" ? false : true
  );
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [InsurerList, setInsurerList] = useState([]);
  const [bikemake, setBikeMake] = useState("");
  const [bikemodel, setModelSearch] = useState("");
  const [bikeVarient, setSelectVarient] = useState("");
  const [saveloading, setIsaveloading] = useState(false);
  const [isNcb, setIsNcb] = useState(
    QuickPost?.isclaim ? QuickPost?.isclaim : false
  );
  const [AadharfileList, setAadharfileList] = useState([]);
  const [PanfileList, setPanfileList] = useState([]);
  const [InspecfileList, setInspecfileList] = useState([]);
  const [CpExpValue, setCpExpValue] = useState(
    QuickPost?.currentPolicyExpired ? QuickPost?.currentPolicyExpired : ""
  );
  const [ReqPolicyValue, setReqPolicyValue] = useState(
    QuickPost?.required_policy_type ? QuickPost?.required_policy_type : ""
  );
  const [PrevPolicyValue, setPrevPolicyValue] = useState(
    QuickPost?.previous_policy_type ? QuickPost?.previous_policy_type : ""
  );
  const [InspectReq, setInspectReq] = useState("");
  const [ShowMore, setShowMore] = useState(false);
  // console.log(bikenum)
  // console.log("vechicleData",vechicleData)
  console.log("notExppp", notExp);
  useEffect(() => {
    dispatch(Previousinsurer())
      .then((res) => {
        console.log("previous insurer", res);
        setInsurerList(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);
  useEffect(() => {
    console.log(bikeNumDetail);
    form.setFieldsValue({
      registrationYear: vechicleData?.registration_date
        ? moment(vechicleData?.registration_date)
        : null,
    });
  }, [vechicleData]);
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  useEffect(() => {
    axiosInPosp
      .get(`vehicle_masters?no_of_wheels=2`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.makes;
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);

  const onSelectMake = (data) => {
    //console.log("onSelect", data);
    setBikeMake(data);
    setIsaveloading(false);
    form.setFieldsValue({
      bikeModel: "",
      bikeVarient: "",
    });
  };
  console.log(bikemake);

  useEffect(() => {
    axiosInPosp
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, [bikemake]);
  const ModelChange = (e) => {
    setModelSearch(e);
    setIsaveloading(false);
  };

  useEffect(() => {
    axiosInPosp
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.variants;
        //console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(resp);
        setVarientData(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemodel]);

  const VarientChange = (variant, option) => {
    //console.log(variant,option)
    setSelectVarient(variant);
    axiosInPosp
      .get(
        `vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        //console.log(resp);
        dispatch(
          addbikedetails({
            ...BikeMakeData,
            VehicleCoreCode: resp?.vehicle_core_code,
            customized_variant: option?.label,
            fuel_type: option?.fuel_type,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    setIsaveloading(false);
  };

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };
  const OnClaimchange = (e) => {
    console.log(e.target.value);
    if (e.target.value === true) {
      setIsNcb(true);
    } else if (e.target.value === false) {
      setIsNcb(false);
    }
  };
  const onDateChange = (date, dateString) => {
    console.log(date);
    console.log(dateString);
    //setRegDate(dateString)
  };
  const handleInputChange = (e) => {
    setIsaveloading(true);
    e.target.value = e.target.value.toUpperCase();
    setBikeNumdeail({
      ...bikeNumDetail,
      bike_number: e.target.value.toUpperCase(),
    });
    form.setFieldsValue({ BikeNumber: e.target.value });
    setIsaveloading(false);
  };
  console.log(bikeNumDetail);
  const onReqTypeChange = (e) => {
    console.log("onReqTypeChange", e.target.value);
    setReqPolicyValue(e.target.value);
    setInspectReq("");
  };
  const onPrevPolChange = (e) => {
    console.log("onPrevPolChange", e.target.value);
    console.log(e.target.value);
    setPrevPolicyValue(e.target.value);
    setInspectReq("");
    if (e.target.value === "Not-Secure") {
      setNotSecure(false);
      setCpExpValue("");
    } else if (e.target.value === "Bundled") {
      // setproductCode(e.target.value)
      setNotSecure(true);
    } else {
      setNotSecure(true);
    }
  };

  const disabledDate = (current) => {
    const currentDate = moment();
    const fiveMonthsFromNow = moment().add(25, "week");
    return (
      current &&
      (current < currentDate.endOf("day") ||
        current > fiveMonthsFromNow.endOf("day"))
    );
  };

  const handleDateChange = (date, dateString) => {
    console.log(date);
    console.log("dateString", dateString);
    setSelectedDate(dateString);
  };
  console.log(selectedDate);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const isuser = JSON.parse(localStorage.getItem("vibeUser"));

  const onReqInsurerChange = (value) => {
    console.log(value);
    const limitedValues = value.slice(0, 3);
    console.log(limitedValues);
    form.setFieldsValue({ required_insurers: limitedValues });
  };
  const AadharProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setAadharfileList([...AadharfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = AadharfileList.indexOf(file);
      const newFileList = AadharfileList.slice();
      newFileList.splice(index, 1);
      setAadharfileList(newFileList);
    },
    AadharfileList,
  };
  const PanProps = {
    multiple: false,
    accept: "application/pdf, .jpg, .png",
    beforeUpload: (file) => {
      setPanfileList([...PanfileList, file]);
      return false;
    },
    onRemove: (file) => {
      const index = PanfileList.indexOf(file);
      const newFileList = PanfileList.slice();
      newFileList.splice(index, 1);
      setPanfileList(newFileList);
    },
    PanfileList,
  };

  const InspectionProps = {
    multiple: true,
    accept: ".jpg, .png",
    beforeUpload: (file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        file.thumbUrl = reader.result;
        setInspecfileList((prevList) => {
          const updatedList = [...prevList, file];
          // form.setFieldsValue({ inspection_images: updatedList });
          // form.validateFields(["inspection_images"]);
          return updatedList;
        });
      };
      return false;
    },
    onRemove: (file) => {
      setInspecfileList((prevList) => {
        const newFileList = prevList.filter((item) => item.uid !== file.uid);
        // form.setFieldsValue({ inspection_images: newFileList });
        // form.validateFields(["inspection_images"]);
        return newFileList;
      });
    },
    fileList: InspecfileList,
    // onPreview: handlePreview,
  };

  // console.log("InspecfileList", InspecfileList);
  // console.log("InspecfileList length", InspecfileList?.length);

  const onExpChange = (e) => {
    console.log(e.target);
    setCpExpValue(e.target.value);
    setnotExp(e.target.value === "NotExpired");
    setInspectReq("");
  };
  const onFinish = (values) => {
    console.log("values", values);
    const productcode = values.previous_policy_type;
    const registrationDate = moment(values.registrationDate).format(
      "YYYY-MM-DD"
    );
    const regDate = new Date(registrationDate);
    regDate.setFullYear(regDate.getFullYear() + 5);
    values.registrationYear = moment(values.registrationYear).format(
      "YYYY-MM-DD"
    );
    console.log(values.registrationYear);
    setLoading(true);
    // values.ncbvalue = "0";
    if (isuser !== null) {
      var is_POSP = isuser.isPOSP === true ? 1 : 0;
      var posp_id = isuser.isPOSP === true ? isuser.pospid : "";
    } else {
      is_POSP = 0;
      posp_id = "";
    }
    let currentTP = {
      currentThirdPartyPolicyNumber:
        productcode === "Standalone own damage" || productcode === "Bundled"
          ? vechicleData?.insurance_policy_number
          : null,
      currentThirdPartyPolicyInsurerCode:
        productcode === "Standalone own damage" || productcode === "Bundled"
          ? values.insuranceProductCode
          : null,
      currentThirdPartyPolicyStartDateTime:
        productcode === "Standalone own damage" || productcode === "Bundled"
          ? moment(values.registrationDate).format("YYYY-MM-DD")
          : null,
      currentThirdPartyPolicyExpiryDateTime:
        productcode === "Standalone own damage" || productcode === "Bundled"
          ? moment(regDate).format("YYYY-MM-DD")
          : null,
    };
    let post = {
      firstName: vechicleData?.owner_name,
      licensePlateNumber: values?.BikeNumber,
      Chasis: vechicleData?.vehicle_chasi_number,
      Engine: vechicleData?.vehicle_engine_number,
      fuel_type: vechicleData?.fuel_type
        ? vechicleData?.fuel_type
        : BikeMakeData?.fuel_type,
      address: vechicleData?.permanent_address,
      previousPolicyNumber:
        productcode === "Not-Secure"
          ? ""
          : vechicleData?.insurance_policy_number
            ? vechicleData?.insurance_policy_number
            : "",
      previous_policy_type: values?.previous_policy_type,
      policyHolderType: values?.PolicyHolderType,
      required_policy_type: values?.required_policy_type,
      required_insurer: values?.required_insurer,
      isVehicleNew: 0,
      product_type: "TWO WHEELER",
      make: values?.bikeMake,
      model: values?.bikeModel,
      variant: values?.bikeVarient,
      previousPolicyExpiryDate:
        productcode === "Not-Secure"
          ? ""
          : moment(values.previousPolicyExpiryDate).format("YYYY-MM-DD"),
      registrationDate: values.registrationYear,
      isPreviousInsurerKnown: productcode === "Not-Secure" ? 0 : 1, //0 r 1 int
      previousInsurerCode:
        productcode === "Not-Secure" ? "" : values?.previousInsurerCode,
      originalPreviousPolicyType:
        productcode === "Standalone own damage"
          ? "1OD_0TP"
          : productcode === "Bundled"
            ? "1OD_5TP"
            : "",
      currentThirdPartyPolicy:
        productcode === "Standalone own damage" || productcode === "Bundled"
          ? currentTP
          : "",
      isClaimInLastYear: values?.isclaim,
      previousNoClaimBonus: values?.isclaim === true ? null : values?.ncbvalue,
      // pincode: '587316',
      isPOSP: true,
      insurance_id: auth.bike_insurance_id,
      // quote_request_from: values?.quote_request_from,
      // pospId: posp_id,
    };
    console.log("post", post);
    console.log("values", values);
    console.log(values?.required_insurers);
    const formData = new FormData();
    Object.keys(post).forEach((key) => {
      formData.append(key, post[key]);
    });
    values?.required_insurers.forEach((insur, index) => {
      console.log(insur, index);
      formData.append(`required_insurers[${index}]`, insur);
    });
    formData.append("aadhaar_copy", AadharfileList[0]);
    formData.append("pancard_copy", PanfileList[0]);
    if (InspecfileList?.length > 0) {
      InspecfileList?.forEach((file, index) => {
        console.log(file, index);
        formData.append(`inspection_images[${index}]`, file);
      });
    } else {
      formData.append("inspection_images", null);
    }
    dispatch(QuickQuote_Post(post));
    dispatch(quick_quoteValues(values));
    axiosInPosp
      .post("v1/posp/quick_quotes", formData)
      .then((res) => {
        console.log(res);
        console.log(res?.status);
        // if (res?.status === 201) {
        const data = res?.data;
        console.log(data);
        message.success("Quote request send successfully");
        // const updateQuoteReq = {
        //   ...QuoteRequest,
        //   quoteRequest: true,
        // };
        // dispatch(OnSendReq(updateQuoteReq));
        // history.push("/");
        setLoading(false);
        history.push("/");
      })
      .catch((err) => {
        console.log("err?.response", err);
        if (err.response) {
          // The server responded with a status code outside the range of 2xx
          console.error("Error Response:", err.response);
          console.error("Status Code:", err.response.status);
          console.error("Error Data:", err.response.data);
        }
        // if (err.response.data.message == "Unauthenticated.") {
        //   dispatch((dispatch) => {
        //     dispatch({ type: "LOGOUT_POSP" });
        //   });
        //   history.push("/");
        // }
        setLoading(false);
        // message.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <PospNavBar />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <div className="col-xl-12 col-lg-12 px-3 col-md-12  bike-info-quotebef">
              <div
                className="h6 text-blue py-3 text-center mb-0"
                style={{ fontSize: "25px", fontWeight: "700" }}
              >
                VEHICLE DETAILS
              </div>
              <Form
                layout={formLayout}
                form={form}
                style={{ width: "100%" }}
                // requiredMark={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item
                      // {...formItemLayout}
                      label="Bike Number"
                      name="BikeNumber"
                      rules={[
                        {
                          pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                          message: "Invalid Vehicle No",
                        },
                        { required: true, message: "Enter Vehicle No" },
                      ]}
                      initialValue={bikenum?.bike_number}
                    >
                      <Input
                        onChange={handleInputChange}
                        placeholder="Enter Bike Number (eg. DL1SAB1234)"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="bikeMake"
                      label="Select Make"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Make",
                        },
                      ]}
                      initialValue={vechicleData?.maker_description}
                    >
                      <AutoComplete
                        placeholder="Select Make"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={MakeData?.map((p, index) => ({
                          key: index,
                          value: p,
                          label: p,
                        }))}
                        // onChange={(e)=>onSelectMake(e)}
                        onSelect={(e) => onSelectMake(e)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="bikeModel"
                      label="Select Model"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Model",
                        },
                      ]}
                      initialValue={vechicleData?.maker_model}
                    >
                      <AutoComplete
                        placeholder="Select Model"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={ModalData?.map((p, index) => ({
                          key: index,
                          value: p,
                          label: p,
                        }))}
                        // onChange={(e)=>ModelChange(e)}
                        onSelect={(e) => ModelChange(e)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="bikeVarient"
                      label="Select Variant"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Variant",
                        },
                      ]}
                      initialValue={BikeMakeData?.varbike}
                    >
                      <AutoComplete
                        //disabled={vechicleData?.variant === null}
                        placeholder="Select Variant"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={VarientData?.map((p, index) => ({
                          key: index,
                          value: p?.variant,
                          label: p?.customized_variant,
                          fuel_type: p?.fuel_type,
                        }))}
                        onChange={(variant, option) =>
                          VarientChange(variant, option)
                        }
                        onSearch={(value) => {
                          const uppercaseValue = value.toUpperCase();
                          form.setFieldsValue({ bikeVarient: uppercaseValue });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      // {...formItemLayout}
                      label="Registration Year"
                      name="registrationYear"
                      rules={[
                        {
                          required: true,
                          message: "please input Registration Year",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%", padding: "8px" }}
                        format="YYYY-MM-DD"
                        onChange={onDateChange}
                        placeholder="Select Registration Date"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="PolicyHolderType"
                      label="Vehicle Owned By ?"
                      rules={[
                        {
                          required: true,
                          message: "Please select PolicyHolderType",
                        },
                      ]}
                      initialValue={
                        QuickPost?.PolicyHolderType
                          ? QuickPost?.PolicyHolderType
                          : "INDIVIDUAL"
                      }
                    >
                      <Select
                        //defaultValue='INDIVIDUAL'
                        placeholder="Select Type"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "INDIVIDUAL",
                            label: "INDIVIDUAL",
                          },
                          {
                            value: "COMPANY",
                            label: "COMPANY",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label="Have Valid Driving Licence ?"
                      name="driverlicence"
                      rules={[
                        {
                          required: true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.driverlicence
                          ? QuickPost?.driverlicence
                          : "Yes"
                      }
                    >
                      <Select
                        placeholder="Select a person"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={[
                          {
                            value: "Yes",
                            label: "Yes",
                          },
                          {
                            value: "No",
                            label: "No",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={14}>
                    <Form.Item
                      {...formItemLayout}
                      name="required_policy_type"
                      label="Required Policy Type"
                      rules={[
                        {
                          required: true,
                          message: "Please select Policy Type",
                        },
                      ]}
                      initialValue={QuickPost?.required_policy_type}
                    >
                      <Radio.Group
                        onChange={onReqTypeChange}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                      >
                        <Radio value="Comprehensive">Comprehensive</Radio>
                        <Radio value="Third Party">Third-Party</Radio>
                        <Radio value="Standalone own damage">SAOD</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    {/* <div className="h6 text-blue mb-3">
                      Select Required insurer
                    </div> */}
                    <Form.Item
                      // {...formItemLayout}
                      name="required_insurers"
                      label="Select Required insurer"
                      rules={[
                        {
                          required: true,
                          message: "Please select previous insurer",
                        },
                      ]}
                      initialValue={QuickPost?.required_insurers}
                    >
                      <Select
                        onChange={onReqInsurerChange}
                        maxTagTextLength={15}
                        // maxTagCount={3}
                        maxTagCount="responsive"
                        className="req-pol-select"
                        mode="multiple"
                        style={{
                          width: "100%",
                        }}
                        placeholder="Select any 3 insurer"
                        showSearch
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        options={InsurerList?.map((p) => ({
                          key: p.id,
                          value: p.name,
                          label: p.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={14}>
                    <Form.Item
                      {...formItemLayout}
                      name="previous_policy_type"
                      label="Previous Policy Type"
                      //className="form-item-bg"
                      rules={[
                        {
                          required: true,
                          message: "Please select Policy Type",
                        },
                      ]}
                      initialValue={QuickPost?.previous_policy_type}
                    >
                      <Radio.Group
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        onChange={onPrevPolChange}
                      >
                        <Radio value="Comprehensive">Comprehensive</Radio>
                        <Radio value="Third Party">Third-Party</Radio>
                        <Radio value="Standalone own damage">SAOD</Radio>
                        <Radio value="Bundled">Bundled</Radio>
                        <Radio value="Not-Secure">Not Secure</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {NotSecure === true ? (
                    <>
                      <Col span={10}>
                        {/* <div className="h6 text-blue mb-3">
                          Select previous insurer
                        </div> */}
                        <Form.Item
                          {...formItemLayout}
                          //className="form-item-bg"
                          label="Select previous insurer"
                          name="previousInsurerCode"
                          rules={[
                            {
                              required: true,
                              message: "Please select previous insurer",
                            },
                          ]}
                          initialValue={QuickPost?.previousInsurerCode}
                        >
                          <Select
                            placeholder="Select your option"
                            showSearch
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            // onChange={handleChange}
                            options={props?.preinslist?.map((p) => ({
                              key: p.id,
                              value: p.name,
                              label: p.name,
                            }))}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={16}>
                        <Form.Item
                          {...formItemLayout}
                          //className="form-item-bg"
                          label="Have Your Current Policy Expired ?"
                          name="currentPolicyExpired"
                          rules={[
                            {
                              required: true,
                              message: "Please select Policy Expired",
                            },
                          ]}
                          initialValue={QuickPost?.currentPolicyExpired}
                        >
                          <Radio.Group
                            className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                            style={{ width: "100%" }}
                            // onChange={(e) => {
                            //   setnotExp(e.target.value === "NotExpired");
                            // }}
                            onChange={onExpChange}
                            defaultValue={
                              notExp === true ? "NotExpired" : undefined
                            }
                          >
                            <Radio value="NotExpired">Not Expired</Radio>
                            <Radio value="Expired Within 90 Days">
                              Expired Within 90 Days
                            </Radio>
                            <Radio value="Expired More Than 90 Days">
                              Expired More Than 90 Days
                            </Radio>
                            <Radio value="I dont Remember">
                              I don't Remember
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      {notExp === true ? (
                        <Col span={8}>
                          {/* <div className="h6 text-blue mb-3">Previous Policy Expiry Date</div> */}
                          <Form.Item
                            {...formItemLayout}
                            //className="form-item-bg"
                            label="Previous Policy Expiry Date"
                            name="previousPolicyExpiryDate"
                            rules={[
                              {
                                required: true,
                                message: "Please select Date",
                              },
                            ]}
                            initialValue={moment(vechicleData?.insurance_upto)}
                          // initialValue={
                          //   QuickPost?.previousPolicyExpiryDate
                          //     ? moment(QuickPost?.previousPolicyExpiryDate)
                          //     : null
                          // }
                          >
                            <DatePicker
                              style={{ width: "100%", padding: "9px 8px" }}
                              // defaultValue={moment(bikeResult.insurance_upto)}
                              disabledDate={disabledDate}
                              onChange={handleDateChange}
                              format="YYYY-MM-DD"
                              placeholder="Select Expiry Date"
                            />
                          </Form.Item>
                        </Col>
                      ) : null}
                    </>
                  ) : null}
                  <Col span={8}>
                    {/* {!notExp ? null : (
                      <div className="h6 text-blue mb-3">PA Cover</div>
                    )} */}
                    <Form.Item
                      {...formItemLayout}
                      //className="form-item-bg"
                      label="Previous PA Cover of Rs 15 Lakh ?"
                      name="paCover"
                      rules={[
                        {
                          required: !NotSecure ? false : true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.paCover ? QuickPost?.paCover : "No"
                      }
                    >
                      <Radio.Group
                        //defaultValue='No'
                        disabled={!NotSecure}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        style={{
                          width: "100%",
                        }}
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    {/* <div className="h6 text-blue mb-3">Owner Change</div> */}
                    <Form.Item
                      {...formItemLayout}
                      //className="form-item-bg"
                      label="Owner Change in Last 12 Month ?"
                      name="ownerChange"
                      rules={[
                        {
                          required: !NotSecure ? false : true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.ownerChange ? QuickPost?.ownerChange : "Yes"
                      }
                    >
                      <Radio.Group
                        //defaultValue='Yes'
                        disabled={!NotSecure}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        style={{
                          width: "100%",
                        }}
                      >
                        <Radio value="Yes">Yes</Radio>
                        <Radio value="No">No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    {/* <div className="h6 text-blue mb-3">Claim</div> */}
                    <Form.Item
                      {...formItemLayout}
                      //className="form-item-bg"
                      label="Claim Made In Expiry Policy"
                      name="isclaim"
                      rules={[
                        {
                          required: !NotSecure ? false : true,
                          message: "Please select",
                        },
                      ]}
                      initialValue={
                        QuickPost?.isclaim ? QuickPost?.isclaim : false
                      }
                    >
                      <Radio.Group
                        disabled={!NotSecure}
                        className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                        style={{
                          width: "100%",
                        }}
                        onChange={OnClaimchange}
                      >
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  {isNcb === false ? (
                    <Col span={8}>
                      {/* <div className="h6 text-blue mb-3">
                    Previous No Claim Bonus (NCB)
                  </div> */}
                      <Form.Item
                        {...formItemLayout}
                        //className="form-item-bg"
                        label="Previous No Claim Bonus(NCB)"
                        name="ncbvalue"
                        initialValue={QuickPost?.ncbvalue}
                      >
                        <Select placeholder="NCB">
                          <Select.Option value="ZERO">0%</Select.Option>
                          <Select.Option value="TWENTY">20%</Select.Option>
                          <Select.Option value="TWENTY_FIVE">25%</Select.Option>
                          <Select.Option value="THIRTY_FIVE">35%</Select.Option>
                          <Select.Option value="FORTY_FIVE">45%</Select.Option>
                          <Select.Option value="FIFTY">50%</Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  ) : null}
                  {(CpExpValue === "Expired More Than 90 Days" &&
                    ReqPolicyValue === "Comprehensive") ||
                    (ReqPolicyValue === "Comprehensive" &&
                      CpExpValue === "I dont Remember") ||
                    (CpExpValue === "I dont Remember" &&
                      ReqPolicyValue === "Standalone own damage") ||
                    (ReqPolicyValue === "Standalone own damage" &&
                      CpExpValue === "Expired More Than 90 Days") ||
                    (ReqPolicyValue === "Comprehensive" &&
                      PrevPolicyValue === "Not-Secure") ||
                    (ReqPolicyValue === "Standalone own damage" &&
                      PrevPolicyValue === "Not-Secure") ? (
                    <Col span={8}>
                      <Form.Item
                        {...formItemLayout}
                        label="Inspection required"
                        name="breakinRequired"
                        rules={[
                          {
                            required: true,
                            message: "Please select",
                          },
                        ]}
                      // initialValue={
                      //   QuickPost?.breakinRequired ? QuickPost?.breakinRequired : "No"
                      // }
                      >
                        <Radio.Group
                          // disabled={!NotSecure}
                          className="py-3 px-3 bg-white ant-radio-layout radio-border-form"
                          style={{
                            width: "100%",
                          }}
                          onChange={(e) => setInspectReq(e.target.value)}
                        >
                          <Radio value="Yes">Yes</Radio>
                          <Radio value="No">No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  ) : null}
                  {InspectReq === "Yes" ? (
                    <Col span={4}>
                      <Form.Item
                        name="inspection_images"
                        label="Inspection Photos"
                        rules={[
                          {
                            required: true,
                            message: "Please Upload Inspection Images",
                          },
                        ]}
                      >
                        <Upload
                          className={
                            ShowMore ? `inspect-view` : `inspect-upload`
                          }
                          {...InspectionProps}
                          maxCount={6}
                          listType="picture"
                        >
                          <Button
                            type="primary"
                            className="upload-kyc-btn"
                            icon={<PlusOutlined />}
                          >
                            Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                      {InspecfileList?.length > 1 ? (
                        <p
                          className="mb-0 show-img-txt"
                          onClick={() => setShowMore(!ShowMore)}
                        >
                          {ShowMore
                            ? `View Less`
                            : `View More (${InspecfileList?.length - 1})`}
                        </p>
                      ) : null}
                    </Col>
                  ) : null}
                  <Col span={4}>
                    <Form.Item
                      name="aadhaar_copy"
                      label="Aadhaar Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...AadharProps} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item
                      name="pancard_copy"
                      label="Pancard Copy"
                      rules={[
                        { required: true, message: "Please Upload Rc Copy" },
                      ]}
                    >
                      <Upload {...PanProps} maxCount={1}>
                        <Button
                          type="primary"
                          className="upload-kyc-btn"
                          icon={<PlusOutlined />}
                        >
                          Upload
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <div
                  className="bg-white position-sticky bottom-0"
                  style={{ height: "50px" }}
                >
                  <div className="d-flex align-items-center justify-content-end container text-right py-2">
                    <Form.Item className="mb-0" {...buttonItemLayout}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                      >
                        SUBMIT
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    product: state.vehicledetail.insuranceproduct,
    preinslist: state.vehicledetail.previnslist,
  };
};

export default connect(mapStateToProps)(PospMake);
